export default __webpack_public_path__ + "static/media/Product Page Nude - Front Outside Nude-03869 copy-sq.d0c4921a.webp";